import React, { useState } from 'react';
import { MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBTypography, MDBCardImage } from 'mdb-react-ui-kit';

import ordersImage from '../assets/images/orders_img.jpg'
import inventoryImage from '../assets/images/inventory_img.jpg'
import productImage from '../assets/images/products_img.jpg'
import reportsImage from '../assets/images/reports_img.jpg'
import staffImage from '../assets/images/staff_img.jpg'

function HomeTab({ user, onTabSelect }) {
  const [activeTab, setActiveTab] = useState(null);

  const allCardsRow1 = [
    { title: 'Orders', description: 'Manage and track all customer orders', image: ordersImage },
    { title: 'Inventory', description: 'Check stock levels and manage items', image: inventoryImage },
    { title: 'Products', description: 'Manage store products', image: productImage },
  ];

  const allCardsRow2 = [
    { title: 'Reports', description: 'View sales and inventory reports', image: reportsImage },
    { title: 'Staff Management', description: 'Manage staff and user roles', image: staffImage },
  ];

  const cardsRow1 = user.role === 'staff'
    ? allCardsRow1.filter(c => c.title === 'Inventory' || c.title === 'Orders')
    : allCardsRow1;

  const cardsRow2 = user.role === 'staff' ? [] : allCardsRow2;

  const imageStyle = {
    height: '250px',
    objectFit: 'cover'
  };

  const handleCardClick = (title) => {
    setActiveTab(title);
    if (onTabSelect) onTabSelect(title); 
  };

  return (
    <div className="mt-4">
      {/* Header */}
      <MDBRow className="align-items-center mb-4">
        <MDBCol>
          <MDBTypography tag="h1" className="custom-font" style={{ color: '#A78D79' }}>
            Home
          </MDBTypography>
        </MDBCol>

        <MDBCol md="auto" className="d-flex align-items-center custom-font">
          <MDBTypography className="me-2" style={{ fontSize: '1.25rem' }}>
            Welcome, {user.firstname} {user.lastname}!
          </MDBTypography>
        </MDBCol>
      </MDBRow>

      {/* First Row */}
      <MDBRow className="mb-4">
        {cardsRow1.map((card, index) => (
          <MDBCol key={index} md={cardsRow1.length === 1 ? 12 : 12 / cardsRow1.length} className="mb-3">
            <MDBCard
              style={{ cursor: 'pointer', border: activeTab === card.title ? '3px solid #A78D79' : '' }}
              onClick={() => handleCardClick(card.title)}
            >
              <MDBCardImage src={card.image} position="top" alt={card.title} style={imageStyle} />
              <MDBCardBody>
                <MDBCardTitle>{card.title}</MDBCardTitle>
                <MDBCardText>{card.description}</MDBCardText>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        ))}
      </MDBRow>

      {/* Second Row */}
      {cardsRow2.length > 0 && (
        <MDBRow>
          {cardsRow2.map((card, index) => (
            <MDBCol key={index} md={4} className="mb-3">
              <MDBCard
                style={{ cursor: 'pointer', border: activeTab === card.title ? '3px solid #A78D79' : '' }}
                onClick={() => handleCardClick(card.title)}
              >
                <MDBCardImage src={card.image} position="top" alt={card.title} style={imageStyle} />
                <MDBCardBody>
                  <MDBCardTitle>{card.title}</MDBCardTitle>
                  <MDBCardText>{card.description}</MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))}
        </MDBRow>
      )}

      {/* Optional: Show active tab content below */}
      {activeTab && (
        <div className="mt-4">
          <MDBTypography tag="h4" style={{ color: '#A78D79' }}>
            {activeTab} Tab Content
          </MDBTypography>
          <p>This is where the {activeTab} component would be rendered.</p>
        </div>
      )}
    </div>
  );
}

export default HomeTab;
